import { useRef, useState } from 'react'

import { config } from '@react-spring/web'
import { ReviewAddIcon } from '@web/../assets/icons'
import classNames from 'classnames'
import { useEffectOnce } from 'react-use'

import Clickable from '@web/components/Clickable'
import Tooltip from '@web/components/Tooltip/Tooltip'
import nClicks from '@web/libs/nlog/click/codes'

import styles from './UserThemelists.module.scss'

interface Props {
  onClick: () => void
}

const NewThemelistButton = ({ onClick }: Props) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)

  const showTimerList = useRef<number[]>([])
  const hideTimerList = useRef<number[]>([])

  const tooltipTransition = {
    config: config.wobbly,
    from: { opacity: 0, transform: 'translateY(-20px)' },
    enter: { opacity: 1, transform: 'translateY(0)' },
    leave: { opacity: 0, transform: 'translateY(-10px)' },
    onStart: () => {
      const hideTimer = window.setTimeout(() => setShowTooltip(false), 5000)
      hideTimerList.current = [...hideTimerList.current, hideTimer]
    },
  }

  useEffectOnce(() => {
    const showTimer = window.setTimeout(() => setShowTooltip(true), 1000)
    showTimerList.current = [...showTimerList.current, showTimer]

    return function cleanUp() {
      showTimerList.current.forEach(timer => window.clearTimeout(timer))
      hideTimerList.current.forEach(timer => window.clearTimeout(timer))
    }
  })

  return (
    <div className={classNames(styles.theme_area, styles.type_empty)}>
      <div className={styles.btn_area}>
        <Clickable className={styles.btn} nClickCode={nClicks.reviewTab.NEWTHEME_1} onClick={onClick}>
          <span className={styles.icon_wrapper}>
            <ReviewAddIcon className={styles.icon} aria-hidden="true" />
          </span>
          테마 만들기
        </Clickable>
        {showTooltip && (
          <div className={styles.ly_tooltip_wrapper}>
            <Tooltip
              pinPosition="top"
              pinStyle={{ left: '50%', transform: 'translateX(-50%) rotate(180deg)' }}
              nClickCloseCode={nClicks.visitDetail.POV_ADD_NOTI}
              transition={tooltipTransition}
            >
              <p className={styles.txt}>내 리뷰만 모아, 테마를 만들어보세요</p>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  )
}

export default NewThemelistButton
